import { Link } from 'react-router-dom';
import { Bell, BellOff, Users } from 'lucide-react';
import type { Auction } from '../types';
import { formatCurrency, participantLabel } from '../lib/format';
import { Timer } from './Timer';

interface Props {
  auction: Auction;
  participantCount?: number;
  notificationsEnabled?: boolean;
  onToggleNotifications?: (auction: Auction, enabled: boolean) => void;
}

export function AuctionCard({ auction, participantCount = 0, notificationsEnabled = true, onToggleNotifications }: Props) {
  const isOpen = auction.status === 'open' && new Date(auction.closes_at).getTime() > Date.now();
  const hasBid = auction.bid_count > 0 && auction.current_winner_id;

  return (
    <article className="auction-card">
      <Link className="auction-card-link" to={`/auctions/${auction.id}`}>
        <div className="auction-image-wrap">
          {auction.image_url ? <img src={auction.image_url} alt="" className="auction-image" /> : <div className="auction-placeholder">🏷️</div>}
          <span className={isOpen ? 'status-pill open' : 'status-pill closed'}>{isOpen ? 'Aperta' : 'Chiusa'}</span>
        </div>
        <div className="auction-card-body">
          <h3>{auction.title}</h3>
          <p className="auction-owner">Messo all’asta da <strong>{participantLabel(auction.creator)}</strong></p>
          <div className="auction-meta">
            <Timer closesAt={auction.closes_at} status={auction.status} />
            <span><Users size={15} /> {participantCount}</span>
          </div>
          <div className="price-row">
            <span>{hasBid ? 'Offerta attuale' : 'Base d’asta'}</span>
            <strong>{formatCurrency(hasBid ? auction.current_amount : auction.starting_price)}</strong>
          </div>
          <div className="leader-row">
            <span>In vantaggio</span>
            <strong>{hasBid ? participantLabel(auction.winner) : 'Nessuna offerta'}</strong>
          </div>
        </div>
      </Link>
      {isOpen && onToggleNotifications && (
        <button
          className="auction-notification-button"
          type="button"
          onClick={() => onToggleNotifications(auction, !notificationsEnabled)}
          aria-label={notificationsEnabled ? `Silenzia notifiche per ${auction.title}` : `Riattiva notifiche per ${auction.title}`}
        >
          {notificationsEnabled ? <Bell size={17} /> : <BellOff size={17} />}
          {notificationsEnabled ? 'Silenzia' : 'Riattiva notifiche'}
        </button>
      )}
    </article>
  );
}
